import React from 'react';

import emblem from 'common/assets/icons/common/rock-west/rw-logo-with-text-small.svg';
import doneImg from 'common/assets/icons/success-failure-warn/success/done-orange.svg';
import warnImg from 'common/assets/icons/success-failure-warn/warn/warning.svg';
import routes from 'common/constants/routing.constants';
import { IS_ROCKWEST } from 'common/utils/style.util';

import { S } from './styled';

export const InfoPagesLayout = ({
  children,
  error,
  to = routes.auth.login.path,
  linkText = 'Back to Login',
}) => (
  <S.BG>
    {IS_ROCKWEST && <S.Logo src={emblem} />}
    <S.Card>
      <S.Title>{children}</S.Title>
      {!error && <S.DoneImg src={doneImg} />}
      {error && <S.DoneImg src={warnImg} />}
      <S.StyledLink to={to}>{linkText}</S.StyledLink>
    </S.Card>
  </S.BG>
);
